import React from "react";
import { Tooltip } from "@culturehq/components";

const ellipsisDefaultStyle = {
  overflow: "hidden",
  overflowWrap: "break-word",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  wordBreak: "break-all"
};

class EllipisWithTooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasOverflowingChildren: false,
      text: undefined,
      prevPropsChildren: props.children
    };
    this.updateOverflow = this.updateOverflow.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.children === state.prevPropsChildren) return null;
    return {
      hasOverflowingChildren: false,
      prevPropsChildren: props.children
    };
  }

  updateOverflow(e) {
    const el = e.target;
    const { hasOverflowingChildren, text } = this.state;

    if (!hasOverflowingChildren && el.scrollWidth > el.clientWidth) {
      this.setState({ hasOverflowingChildren: true });
      if (el.textContent !== text) {
        this.setState({ text: el.textContent });
      }
    } else {
      this.setState({ hasOverflowingChildren: false });
    }
  }

  render() {
    const { hasOverflowingChildren, text } = this.state;
    const {
      style = {},
      children
    } = this.props;
    const ellipsisStyle = { ...ellipsisDefaultStyle, ...style };

    return hasOverflowingChildren ? (
      <Tooltip tip={text}>
        <span style={ellipsisStyle}>{children}</span>
      </Tooltip>
    ) : (
      <span style={ellipsisStyle} onMouseEnter={this.updateOverflow}>
        {children}
      </span>
    );
  }
}

export default EllipisWithTooltip;
